module.exports = __webpack_public_path__ + "img/enerman-etisol_new.cb8c32db.png";